import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-mist energy-glow-light py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-160" data-mp="1j8p1xdh65dik">
      <div className="mx-auto max-w-3xl px-4" data-id="element-161" data-mp="1n9ioa2eyqk9c">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-162" data-mp="1ncn3rvxvp2fb">
          Elige tu pack
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border border-line bg-white shadow-lift" data-id="element-163" data-mp="1x86rhv2agusz">
          <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-164" data-mp="22830y9tr9efx" />
          <div className="p-6 sm:p-10" data-id="element-165" data-mp="2up5ichj8602">
            <span className="inline-flex items-center gap-2 rounded-md bg-navy px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-greenGlow" data-id="element-166" data-mp="2vqod34shwsc">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="1mgenfk0zkwd2" /> Oferta principal
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-line pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-168" data-mp="1hq7xnguqn5t8">
              <div data-id="element-169" data-mp="1crwqjdvtv9ep">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-ink" data-id="element-170" data-mp="1crep82ub64zx">{productName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-171" data-mp="17ppc8hnizh97">
                  Los {totalVolumes} tomos + {totalBonuses} bonos estratégicos listos para usar en el aula.
                </p>
              </div>
              <div className="sm:text-right" data-id="element-172" data-mp="20emrebwfwxxq">
                <span className="text-sm text-muted" data-id="element-173" data-mp="1vgbgryybmjeg">
                  Precio regular <span className="line-through" data-id="element-174" data-mp="1rg1bkoicrx0n">{priceBefore}</span>
                </span>
                <p className="mt-1 font-display text-5xl font-extrabold text-navy" data-id="element-175" data-mp="k27qb2qxzde5">{price}</p>
                <p className="text-xs font-extrabold uppercase tracking-[.16em] text-greenDark" data-id="element-176" data-mp="jzv0k3exzyqj">
                  Hoy · 50% de descuento
                </p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-177" data-mp="hfx8plemn9k4">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-ink" data-id="element-178" data-mp="mes03bqnu6fu">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green" aria-hidden="true" data-id="element-179" data-mp="7lohr258voo2" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-180" data-mp="3uvmsfx9u08fo">
              Quiero el Megapack
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-181" data-mp="3kyqhzm0dhc8h">
              <span className="inline-flex items-center gap-1.5" data-id="element-182" data-mp="3px1slyyhrqrr">
                <LockIcon className="h-4 w-4 text-navy" aria-hidden="true" data-id="element-183" data-mp="3pv8ho7guikdy" /> Pago seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-184" data-mp="3fzdur05la35d">
                <ZapIcon className="h-4 w-4 text-navy" aria-hidden="true" data-id="element-185" data-mp="3fylyro82y3ek" /> Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-186" data-mp="2xd7hzipo5oj9">
                <ShieldCheckIcon className="h-4 w-4 text-green" aria-hidden="true" data-id="element-187" data-mp="2sdbls5n7r1e9" /> Garantía 7 días
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-188" data-mp="369f2cw55zb89">
              Pagas en USD. Tu plataforma de pago muestra la conversión a tu moneda local automáticamente.
            </p>
          </div>
        </article>
      </div>
    </section>;
}